__turbopack_context__.v({
  "animated": "chevron-module-scss-module__9xAvBW__animated",
  "down": "chevron-module-scss-module__9xAvBW__down",
  "fill-currentColor": "chevron-module-scss-module__9xAvBW__fill-currentColor",
  "fill-step-almost-black": "chevron-module-scss-module__9xAvBW__fill-step-almost-black",
  "fill-step-amethyst": "chevron-module-scss-module__9xAvBW__fill-step-amethyst",
  "fill-step-before-midnight": "chevron-module-scss-module__9xAvBW__fill-step-before-midnight",
  "fill-step-black": "chevron-module-scss-module__9xAvBW__fill-step-black",
  "fill-step-black-v2": "chevron-module-scss-module__9xAvBW__fill-step-black-v2",
  "fill-step-coal-mine-canary": "chevron-module-scss-module__9xAvBW__fill-step-coal-mine-canary",
  "fill-step-coal-mine-canary-down": "chevron-module-scss-module__9xAvBW__fill-step-coal-mine-canary-down",
  "fill-step-cold-steel": "chevron-module-scss-module__9xAvBW__fill-step-cold-steel",
  "fill-step-cyanora": "chevron-module-scss-module__9xAvBW__fill-step-cyanora",
  "fill-step-cyanora-down": "chevron-module-scss-module__9xAvBW__fill-step-cyanora-down",
  "fill-step-dark-grey": "chevron-module-scss-module__9xAvBW__fill-step-dark-grey",
  "fill-step-dark-text": "chevron-module-scss-module__9xAvBW__fill-step-dark-text",
  "fill-step-diagonal-gradient-midnight-haze-to-black": "chevron-module-scss-module__9xAvBW__fill-step-diagonal-gradient-midnight-haze-to-black",
  "fill-step-future-fuscia": "chevron-module-scss-module__9xAvBW__fill-step-future-fuscia",
  "fill-step-future-fuscia-down": "chevron-module-scss-module__9xAvBW__fill-step-future-fuscia-down",
  "fill-step-light-text": "chevron-module-scss-module__9xAvBW__fill-step-light-text",
  "fill-step-linear-gradient-cyanora-to-future-fuscia": "chevron-module-scss-module__9xAvBW__fill-step-linear-gradient-cyanora-to-future-fuscia",
  "fill-step-midnight": "chevron-module-scss-module__9xAvBW__fill-step-midnight",
  "fill-step-negative": "chevron-module-scss-module__9xAvBW__fill-step-negative",
  "fill-step-off-white": "chevron-module-scss-module__9xAvBW__fill-step-off-white",
  "fill-step-positive": "chevron-module-scss-module__9xAvBW__fill-step-positive",
  "fill-step-right-before-black": "chevron-module-scss-module__9xAvBW__fill-step-right-before-black",
  "fill-step-right-before-midnight": "chevron-module-scss-module__9xAvBW__fill-step-right-before-midnight",
  "fill-step-secondary-text": "chevron-module-scss-module__9xAvBW__fill-step-secondary-text",
  "fill-step-vertical-gradient-cyanora-to-future-fuscia": "chevron-module-scss-module__9xAvBW__fill-step-vertical-gradient-cyanora-to-future-fuscia",
  "fill-step-warning": "chevron-module-scss-module__9xAvBW__fill-step-warning",
  "fill-step-white": "chevron-module-scss-module__9xAvBW__fill-step-white",
  "left": "chevron-module-scss-module__9xAvBW__left",
  "right": "chevron-module-scss-module__9xAvBW__right",
  "up": "chevron-module-scss-module__9xAvBW__up",
});
